import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Container = styled.div<{ $columns: number }>`
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  padding: 24px 16px;

  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
  gap: 16px;
  align-items: start;
  overflow-x: auto;

  @media (max-width: 768px) {
    gap: 0;
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
    overflow-x: hidden;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding-right: 16px;
  border-right: 1px solid ${colors.stroke['soft-200']};

  &:last-child {
    padding-right: 0;
    border-right: 0;
  }

  @media (max-width: 768px) {
    padding: 12px 0;
    padding-right: 0;
    border-right: 0;
    border-bottom: 0;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${colors.brand.primary.light};
  color: ${colors.brand.primary.base};
  flex-shrink: 0;
`;

export const ValueWrapper = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
`;

export const MainValue = styled.span`
  font-size: 32px;
  font-weight: 700;
  line-height: 1.1;
  color: ${colors.text['main-900']};
  white-space: nowrap;
`;

export const UnitValue = styled.span`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  color: ${colors.text['sub-500']};
  white-space: nowrap;
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.text['main-900']};
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;
